import { Component, OnInit } from '@angular/core';
import {PostsService} from '../common/services/posts.service';
import {PostDO} from '../common/data-objects/PostDO';
import {ToastrService} from 'ngx-toastr';
import { Meta, Title } from '@angular/platform-browser';
import { Angulartics2 } from 'angulartics2';
import { SeoService } from '../common/services/seo.service';

@Component({
  selector: 'app-reviews-page',
  templateUrl: './reviews-page.component.html',
  styleUrls: ['./reviews-page.component.scss']
})
export class ReviewsPageComponent implements OnInit {
  posts: PostDO[];
  isLoading: boolean;

  constructor(
    private postsService: PostsService,
    private toastr: ToastrService,
    private titleService: Title,
    private angulartics2: Angulartics2,
    private meta: Meta,
    private seoService: SeoService
  ) {
    this.seoService.setTitle('Recenzii jocuri biblice și cărți creștine pentru copii - Fun Bible');
    this.seoService.setDescription('Recenzii de jocuri biblice online si offline, cărți creștine pentru copii și alte produse pentru copii');
    this.meta.updateTag({ property: 'og:url', content: 'https://funbible.net/reviews/' });
    this.meta.updateTag({ property: 'og:image', content: 'https://funbible.net/assets/reviews.png' });
    const initialKeywords = ['recenzii jocuri biblice', 'reviewuri carti crestine', 'reviews jocuri biblice','jocuri gratuite', 'jocuri de copii', 'jocuri ptr copii', 'jocuri online copii', 'povesti pentru copii', 'povestire biblica', 'jocuri gratis'].join();
    this.meta.updateTag({property: 'keywords', content: initialKeywords});
    this.angulartics2.eventTrack.next({
      action: 'Reviews',
      properties: { category: 'pageView' },
    });
  }

  ngOnInit() {
    this.isLoading = true;
    this.postsService.getReviews(15).subscribe((postsData) => {
      this.posts = postsData.posts;
      this.isLoading = false;
    }, () => {
      this.toastr.error('Acest conținut nu s-a putut încărca!');
      this.isLoading = false;
    });
  }

}
